export default __webpack_public_path__ + "static/media/Quantum_IconMain.610ee5a4.svg";